// src/i18n.js - Improved language detection
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Initialize i18next with enhanced language detection
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    // Backend configuration
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
      requestOptions: {
        cache: 'no-cache' // Prevent caching issues
      }
    },
    
    interpolation: {
      escapeValue: false,
    },
    
    // Improved detection configuration
    detection: {
      // Prioritize navigator (browser language) first
      order: ['navigator', 'querystring', 'localStorage', 'htmlTag'],
      
      // Ensure we detect from these localStorage keys
      lookupLocalStorage: ['i18nextLng', 'bitdogSettings'],
      
      // Parse custom localStorage formats
      parseLocalStorageItem: (lng) => {
        try {
          // Check if this is our settings object (bitdogSettings)
          if (lng && lng.startsWith('{')) {
            const parsed = JSON.parse(lng);
            if (parsed.language) {
              return parsed.language;
            }
          }
          return lng;
        } catch (e) {
          return lng;
        }
      },
      
      // Cache results
      caches: ['localStorage'],
      
      // Normalize language codes (e.g., convert 'en-US' to 'en')
      convertDetectedLanguage: (lng) => lng.split('-')[0],
      
      // Don't filter by whitelist (improved detection)
      checkWhitelist: false
    },
    
    react: {
      useSuspense: true,
    },
  });

// Add logging
i18n.on('initialized', () => {
  console.log('i18next initialized with language:', i18n.language);
});

i18n.on('languageChanged', (lng) => {
  console.log('i18next language changed to:', lng);
});

// Log more information about the detected language
console.log('Browser language:', navigator.language);
console.log('i18next default language:', i18n.options.fallbackLng);

export default i18n;